export default "__VITE_ASSET__BirYydhr__"